export default __webpack_public_path__ + "static/media/ic_styled_send.453daa08.svg";